export const clientRoles = {
  ACCESS_CATALOG: 'access-catalog',
  ACCESS_ARCHIVE: 'access-archive',
  ACCESS_PUBLISH: 'access-publish',
  ACCESS_SUBADMIN: 'access-subadmin',
  ACCESS_ADMIN: 'access-admin',
  ACCESS_SETTINGS: 'access-settings',
  ACCESS_SEARCH: 'access-search',
  IS_ADMIN: 'is-admin',
  IS_SUBADMIN: 'is-subadmin',
  IS_AUTHOR: 'is-author',
  IS_USER: 'is-user',
};
